import { Component, inject, output, signal } from '@angular/core';
import { ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ImportGrundAdminCmd } from '@app/shared/classes/import-grund';
import { BackendService } from '@app/shared/services/backend.service';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-admin-stammdaten-importgrund-new',
  templateUrl: './admin-stammdaten-importgrund-new.component.html',
  imports: [
    TranslatePipe,
    ReactiveFormsModule,
  ],
})
export class AdminStammdatenImportgrundNewComponent {
  private readonly backendService = inject(BackendService);
  private readonly translateService = inject(TranslateService);
  private readonly formBuilder = inject(UntypedFormBuilder);

  readonly reloadEntries = output();

  protected readonly newGrundForm = signal(this.generateForm());

  private generateForm(): UntypedFormGroup {
    return this.formBuilder.group({
      bezeichnungDe_new          : ['', Validators.required],
      bezeichnungFr_new          : ['', Validators.required],
      bezeichnungIt_new          : ['', Validators.required],
      sortierung_new             : ['', [Validators.pattern('^[0-9]*$'), Validators.required]],
      kommentarPflicht_new       : [''],
      zulassungsNrChAnzeigen_new : [''],
      lieferEngpassAnzeigen_new  : [''],
      aktiv_new                  : ['']
    });
  }

  protected submit() {
    const formValues = this.newGrundForm().value;
    const grund = new ImportGrundAdminCmd({
      bezeichnungDe          : formValues.bezeichnungDe_new,
      bezeichnungFr          : formValues.bezeichnungFr_new,
      bezeichnungIt          : formValues.bezeichnungIt_new,
      sortierung             : formValues.sortierung_new,
      kommentarPflicht       : formValues.kommentarPflicht_new,
      zulassungsNrChAnzeigen : formValues.zulassungsNrChAnzeigen_new,
      lieferEngpassAnzeigen  : formValues.lieferEngpassAnzeigen_new,
      aktiv                  : formValues.aktiv_new,
    });
    this.backendService.createImportgrund(grund)
      .subscribe({
        next: () => {
          this.reset();
          this.reloadEntries.emit();
        },
        error: error => {
          this.showAlert();
          console.error(error);
        }
      });
  }

  protected reset() {
    this.newGrundForm.set(this.generateForm());
  }

  private showAlert() {
    Swal.fire({
      text              : this.translateService.instant('admin.importgrund.save.error'),
      icon              : 'error',
      buttonsStyling    : true,
      confirmButtonText : this.translateService.instant('global.ok')
    });
  }
}
